<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      :color="color"
      :flat="disableHoverShadow ? true : !hover"
      class="pa-1"
      :ripple="false"
      @click="handleFocus"
      @dblclick="$emit('doubleClick')"
      @blur="focused = false"
      @dragstart="$emit('dragStart')"
      @keydown.down="$emit('keyDown')"
      @keydown.up="$emit('keyUp')"
      @keydown.delete="$emit('delete')"
      @keydown.enter.prevent.stop="$emit('keyEnter')"
    >
      <slot :hover="hover"></slot>
      <resource-block v-bind="$props" :hovering="hover"></resource-block>
      <slot name="after" :hover="hover"></slot>
    </v-card>
  </v-hover>
</template>

<script>
import ResourceBlock from './ResourceBlock';

export default {
  components: { ResourceBlock },
  props: {
    blockData: {
      default: () => ({
        resource: {},
        excerpts: [],
        showSource: false
      })
    },
    variant: {},
    blockType: {}, // Note, resource, excerpt
    color: { default: 'white' },
    disableHoverShadow: { default: false }
  },
  data() {
    return {
      focused: false
    };
  },
  methods: {
    handleFocus() {
      this.$emit('clicked');
      this.focused = true;
    }
  }
};
</script>

<style scoped>
.resource-card {
  width: 100%;
}
</style>

<style>
.resource-card .title {
  font-size: 15px !important;
}
</style>
